export default "__VITE_ASSET__DtrsBAWY__"